<!-- MDC: [tabPanel] ist Pflicht; wir nutzen die Nav nur als Menue, daher leeres Panel. -->
<nav mat-tab-nav-bar class="sticky" [tabPanel]="tabPanel">
  @for (
    menuItem of menus | async | filterArray: 'visibleOnHeader' : false : false;
    track menuItem
  ) {
    <!-- link -->
    @if (menuItem.type === 'link') {
      <button
        mat-button
        [routerLink]="buildRoute([menuItem.route])"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        @if (menuItem.icon) {
          <mat-icon class="menu-icon">{{ menuItem.icon }}</mat-icon>
        }
        <span class="menu-name">{{ menuItem.name | translate }}</span>
        @if (menuItem.label) {
          <span class="badge menu-label bg-{{ menuItem.label.color }}">
            {{ menuItem.label.value }}
          </span>
        }
        @if (menuItem.badge) {
          <span class="badge menu-badge bg-{{ menuItem.badge.color }}">
            {{ menuItem.badge.value }}
          </span>
        }
      </button>
    }
    <!-- extLink -->
    @if (menuItem.type === 'extLink') {
      <a mat-button [href]="menuItem.route">
        @if (menuItem.icon) {
          <mat-icon class="menu-icon">{{ menuItem.icon }}</mat-icon>
        }
        <span class="menu-name">{{ menuItem.name | translate }}</span>
        @if (menuItem.label) {
          <span class="badge menu-label bg-{{ menuItem.label.color }}">
            {{ menuItem.label.value }}
          </span>
        }
        @if (menuItem.badge) {
          <span class="badge menu-badge bg-{{ menuItem.badge.color }}">
            {{ menuItem.badge.value }}
          </span>
        }
      </a>
    }
    <!-- extTabLink -->
    @if (menuItem.type === 'extTabLink') {
      <a mat-button [href]="menuItem.route" target="_blank">
        @if (menuItem.icon) {
          <mat-icon class="menu-icon">{{ menuItem.icon }}</mat-icon>
        }
        <span class="menu-name">{{ menuItem.name | translate }}</span>
        @if (menuItem.label) {
          <span class="badge menu-label bg-{{ menuItem.label.color }}">
            {{ menuItem.label.value }}
          </span>
        }
        @if (menuItem.badge) {
          <span class="badge menu-badge bg-{{ menuItem.badge.color }}">
            {{ menuItem.badge.value }}
          </span>
        }
        <mat-icon>launch</mat-icon>
      </a>
    }
    <!-- sub drop down -->
    @if (menuItem.type === 'sub') {
      <button mat-button [matMenuTriggerFor]="menulevel1" routerLinkActive="active">
        <mat-icon class="menu-icon">{{ menuItem.icon }}</mat-icon>
        <span class="menu-name">{{ menuItem.name | translate }}</span>
        @if (menuItem.label) {
          <span class="badge menu-label bg-{{ menuItem.label.color }}">
            {{ menuItem.label.value }}
          </span>
        }
        @if (menuItem.badge) {
          <span class="badge menu-badge bg-{{ menuItem.badge.color }}">
            {{ menuItem.badge.value }}
          </span>
        }
        <mat-icon class="menu-caret">arrow_drop_down</mat-icon>
        <!-- menu level 1 -->
        <mat-menu #menulevel1="matMenu">
          @for (childLvl1 of menuItem.children; track childLvl1) {
            <!-- link sub level 1 -->
            @if (childLvl1.type === 'link') {
              <button
                mat-menu-item
                [routerLink]="buildRoute([menuItem.route, childLvl1.route])"
                routerLinkActive="active"
              >
                <mat-icon class="menu-icon">{{ childLvl1.icon }}</mat-icon>
                {{ childLvl1.name | translate }}
              </button>
            }
            <!-- extLink sub level 1 -->
            @if (childLvl1.type === 'extLink') {
              <a mat-menu-item [href]="childLvl1.route">
                <span class="menu-name">{{ childLvl1.name | translate }}</span>
                <mat-icon>launch</mat-icon>
              </a>
            }
            <!-- extTabLink sub level 1 -->
            @if (childLvl1.type === 'extTabLink') {
              <a mat-menu-item [href]="childLvl1.route" target="_blank">
                <span class="menu-name">{{ childLvl1.name | translate }}</span>
                <mat-icon>launch</mat-icon>
              </a>
            }
            <!-- drop down level 1 -->
            @if (childLvl1.type === 'sub') {
              <button mat-menu-item [matMenuTriggerFor]="menulevel2" routerLinkActive="active">
                {{ childLvl1.name | translate }}
                <!-- menu level 2 -->
                <mat-menu #menulevel2="matMenu">
                  @for (childLvl2 of childLvl1.children; track childLvl2) {
                    <!-- link level 2 -->
                    @if (childLvl2.type === 'link') {
                      <button
                        mat-menu-item
                        [routerLink]="
                          buildRoute([menuItem.route, childLvl1.route, childLvl2.route])
                        "
                        routerLinkActive="active"
                      >
                        {{ childLvl2.name | translate }}
                      </button>
                    }
                    <!-- extLink level 2 -->
                    @if (childLvl2.type === 'extLink') {
                      <a mat-menu-item [href]="childLvl2.route">
                        <span class="menu-name">{{ childLvl2.name | translate }}</span>
                        <mat-icon>launch</mat-icon>
                      </a>
                    }
                    <!-- extTabLink level 2-->
                    @if (childLvl2.type === 'extTabLink') {
                      <a mat-menu-item [href]="childLvl2.route" target="_blank">
                        <span class="menu-name">{{ childLvl2.name | translate }}</span>
                        <mat-icon>launch</mat-icon>
                      </a>
                    }
                  }
                </mat-menu>
              </button>
            }
          }
        </mat-menu>
      </button>
    }
  }
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
